import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 10, viewBox: "0 0 16 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L8 8L15 1", stroke: "currentColor", strokeWidth: 1.5 }));
export default SvgArrowUp;
